import React from 'react';
import Login from './Login';
import AuthLayout from 'components/layout/AuthLayout';
import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const LoginContainer = () => {
    return (
        <AuthLayout>
            <Box>
                <Typography
                    variant="overline"
                    className="u-p-small u-text-center"
                >
                    Sign In
                </Typography>
                <Login />
            </Box>
        </AuthLayout>
    );
};

export default LoginContainer;
